import React, { useRef, useState } from 'react';
import './App.css';

// Import Firebase SDKs
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { 
  getFirestore, 
  collection, 
  query, 
  orderBy, 
  limit, 
  serverTimestamp,
  addDoc
 } from "firebase/firestore";
// getRedirectResult, signInWithRedirect,
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";

// Import Firebase react hooks
import { useAuthState } from 'react-firebase-hooks/auth';
import { useCollectionData } from 'react-firebase-hooks/firestore';

// Firebase yeetriumga project config
const firebaseConfig = {
  apiKey: "AIzaSyAgFfTGweoQTTU25-QTN2xjihZ6r_09XPw",
  authDomain: "yeetriumga.firebaseapp.com",
  projectId: "yeetriumga",
  storageBucket: "yeetriumga.appspot.com",
  messagingSenderId: "1040379962112",
  appId: "1:1040379962112:web:3cd673bf7bdcc45120c9e5",
  measurementId: "G-LCRM1CESNT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const analytics = getAnalytics(app);

function App() {
  const [user] = useAuthState(auth);
  logEvent(analytics, 'notification_received');

  return (
    <div className="App">
      <header>
        <h1>⚛️🔥💬</h1>
        <SignOut />
      </header>

      <section>
        {user ? <ChatRoom /> : <SignIn />}
      </section>
    </div>
  );
}

function SignIn() {
  const signInWithGoogle = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
    .then((result) => {
      // The signed-in user info.
      const user = result.user;
      console.log(`Google user ${user.displayName} logged in.`);
    }).catch((error) => {
      // Handle Errors here.
      const errorCode = error.code;
      const errorMessage = error.message;
      // The email of the user's account used.
      const email = error.customData.email;
      // The AuthCredential type that was used.
      const credential = GoogleAuthProvider.credentialFromError(error);
      console.log('%c Errors:', 'color: orange; font-weight:bold;');
      console.log({ errorCode, errorMessage, email, credential});
    });
  }
  return (
      <button 
        className="sign-in" 
        onClick={signInWithGoogle}>Sign in with Google
      </button>
  )
}

function SignOut() {
  return auth.currentUser && (
    <button className="sign-out" onClick={() => auth.signOut()}>Sign Out</button>
  )
}

function ChatRoom() {
  const dummy = useRef();
  const messagesRef = collection(db, 'messages');
  const q = query(messagesRef, orderBy("createdAt"), limit(25));

  const [messages] = useCollectionData(q, { idField: 'id' });

  const [formValue, setFormValue] = useState('');


  const sendMessage = async (e) => {
    e.preventDefault();

    const { uid, photoURL } = auth.currentUser;

    // Add a new document in collection "messages"
    // Add a new document with a generated id.
    await addDoc(messagesRef, {
      text: formValue,
      createdAt: serverTimestamp(),
      uid,
      photoURL
    });

    setFormValue('');
    dummy.current.scrollIntoView({ behavior: 'smooth' });
  }

  return (<>
    <main>
      {messages && messages.map(msg => <ChatMessage key={msg.id} message={msg} />)}
      <span ref={dummy}></span>
    </main>

    <form onSubmit={sendMessage}>
      <input value={formValue} onChange={(e) => setFormValue(e.target.value)} placeholder="say something nice" />
      <button type="submit" disabled={!formValue}>🕊️</button>
    </form>
  </>)
}


function ChatMessage(props) {
  const { text, id, uid, photoURL } = props.message;

  const messageClass = uid === auth.currentUser.uid ? 'sent' : 'received';

  return (<>
    <div key={id} className={`message ${messageClass}`}>
      <img src={photoURL} alt="profilePic" />
      <p>{text}</p>
    </div>
  </>)
}

export default App;
